<template>
    <KRHPPaigutus>
        <template #pais>
            <v-row>
                <v-col>
                    <VoHoiatus class="ma-2"></VoHoiatus>
                    <h1 class="px-2">Üldkasulik töö</h1>
                    <p class="px-2 text-textDark text-justify mt-3" v-if="lehePaiseTekst && lehePaiseTekstLuhendatud">
                        <VoKuvaRohkem :terveTekst="lehePaiseTekst" :luhendatudTekst="lehePaiseTekstLuhendatud">
                        </VoKuvaRohkem>
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <UldkasulikTooTabel :elemendid="elemendid" :laeb="laeb" :aluseId="aluseId"
                        :broneeringuId="broneeringuId" :ajakavaId="ajakavaId">
                    </UldkasulikTooTabel>
                </v-col>
            </v-row>
        </template>
    </KRHPPaigutus>
</template>

<style scoped></style>

<script lang="ts">
import { defineComponent } from 'vue';
import KRHPPaigutus from './uldine/KRHPPaigutus.vue';
import mixin from '@/core/mixins';
import { UldkasilikTooTeenus } from '@/core/uldkasuliktoo-teenus';
import { UldkasulikToo } from '@/models/UldkasulikToo';
import { useUldkasulikTooStore } from '@/stores/uldkasulikTooStore';
import UldkasulikTooTabel from './UldkasulikToo/UldkasulikTooTabel.vue';

const _uldkasulikTooTeenus = new UldkasilikTooTeenus();

export default defineComponent({
    name: 'UldkasulikToo',
    components: { KRHPPaigutus, UldkasulikTooTabel },
    props: {
        aluseId: Number,
        broneeringuId: Number,
        ajakavaId: Number,
    },
    data() {
        return {
            lehePaiseTekst: `<p class="py-3">Üldkasulik töö on asenduskaristus, kus süüdimõistetule on antud võimalus vangistuse asemel temale mõistetud karistus täide 
                viia oma igapäevases keskkonnas, täites oma vaba aja arvelt täiendavaid töökohustusi selle eest tasu saamata.</p>
<p class="py-3">Ametnik koostab koostöös Teie ja tööandjaga üldkasuliku töö ajakava. Ühele päevale arestile või vangistusele vastab üks tund üldkasulikku tööd. Siin näete, 
    kui palju üldkasuliku töö tunde Teile määrati, kui palju olete juba ära teinud ning kui palju üldkasuliku töö tunde on veel vaja teha. Palun arvestage, et 
    ametnik sisestab Teie poolt sooritatud tunnid pärast tööandjalt arvestuslehe saamist esimesel võimalusel.</p>
<p class="py-3">Palun sooritage üldkasuliku töö tunde vastavalt ajakavale ning minge õigeaegselt tööle – tööandja arvestab Teie panusega!</p>
<p class="py-3">Kui Teil on vaja muuta üldkasuliku töö ajakava seitsmest päevast pikema perioodi ulatuses, siis esmalt kontakteeruge enda ametnikuga ning andke teada enda 
    soovist ajakava muuta. Tooge välja muutmise vajaduse põhjus ning muudatuse ettepanek. Seejärel toimige vastavalt ametniku juhistele. Kui muutmine on 
    põhjendatud, teeb ametnik asjakohase muudatuse.</p>`,
            lehePaiseTekstLuhendatud: `<p class="pt-3"></p>Üldkasulik töö on asenduskaristus, kus süüdimõistetule on antud võimalus vangistuse asemel temale mõistetud karistus täide viia oma igapäevases keskkonnas, täites oma vaba aja arvelt täiendavaid töökohustusi selle eest tasu saamata... `,
            laeb: false,
            elemendid: new Array<UldkasulikToo>(),
        }
    },
    mixins: [mixin],
    methods: {
        minuUldkasulikTooInfo() {
            if (this.uldkasulikTooStore.uldkasulikTooSaadud) {
                Object.assign(this.elemendid, this.uldkasulikTooStore.uldkasulikToo);
                this.laeb = false;
            }
            else {
                this.laeb = true;
            }

            _uldkasulikTooTeenus.minuUldkasulikTooInfo().then((uldkasulikToo) => {
                this.uldkasulikTooStore.satiUldkasulikToo(uldkasulikToo);
                this.elemendid = uldkasulikToo;
            }).finally(() => {
                this.laeb = false;
            });
        }
    },
    mounted() {
        this.minuUldkasulikTooInfo();
    },
    setup() {
        return {
            uldkasulikTooStore: useUldkasulikTooStore()
        }
    }
});
</script>
